import { messages as portugueseMessages } from "./pt"; 

const messages = {
	...portugueseMessages, 
};

export { messages };
